        /* eslint-disable react-hooks/exhaustive-deps */
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import produce from "immer";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormClipboardImage from "../../../shared/forms/FormFields/FormClipboardImage";


const CentroCostosPV = ({viaje, errors,actualizar, soloLectura = false}) => {
const actualizarItem = (index, field, value) => {
    const original = viaje.centroCostosViaje ?? [];

    const newList = produce(original, draft => {
        draft[index][field] = value;
    });

    actualizar(newList, 'centroCostosViaje');
};

const agregarConfiguracion = () => {
    const original = viaje?.centroCostosViaje ?? [];

    const newList = produce(original, draft => {
        draft.push({
            nombre: '',
            cantidad: '',
            centroCostoId: null
        });
    });

    actualizar(newList, 'centroCostosViaje');
};


const eliminar = (index) => {
    const newList = produce(viaje.centroCostosViaje, draft => {
        draft.splice(index, 1);
    });

    actualizar(newList, 'centroCostosViaje');
};

  const setViaje = (next) => {
    const nextModel = typeof next === "function" ? next(viaje) : next;
    if (!nextModel) return;
    const keys = new Set([...Object.keys(viaje ?? {}), ...Object.keys(nextModel)]);
    for (const key of keys) {
      const prevVal = viaje?.[key];
      const nextVal = nextModel[key];
      if (prevVal !== nextVal) {
        actualizar(nextVal, key);
      }
    }
  };


    return (
        <>            
            <div className="contTabla">
                 <th className="header-icons" >
                    <div className="d-flex">
                         <ButtonIcon
                        title={"Agregar Pallets"}
                        className="grid-action"
                        iconName={"SiAddthis"}
                        onClick={agregarConfiguracion}
                        autoFocus
                    />
                    </div>
                </th>
                <table className="table tabla">
                        <thead className="thead-light head">
                        <tr>
                            <th/>
                            <th scope="col">
                                CANTIDAD DE PALLETS
                            </th>
                            <th scope="col">
                              CENTRO DE COSTOS
                            </th>
                        
                        </tr>
                        </thead>
                            <tbody>
                            {viaje?.centroCostosViaje?.map((item, index) => {
                                return (
                                       <tr key={index}>
                                        <td className="input">
                                            <FieldTextBox
                                                name={`centroCostosViaje[${index}].cantidadPallets`}
                                                value={item.cantidadPallets}
                                                onChange={e => actualizarItem(index, 'cantidadPallets', e)}
                                                placeholder="Pallets"
                                                type="number"
                                                disabled={soloLectura}
                                                
                                            />
                                        </td>

                                        <td className="input">
                                            <FieldDropDown
                                                name={`centroCostosViaje[${index}].id`}
                                               value={item.centroCostosViaje?.id ?? null}
                                                onChange={e => actualizarItem(index, 'centroCostosViaje', e)}
                                                source="clienteCentroCostos"
                                                required={true}                                               
                                                params={{clienteId: viaje.cliente?.id}}
                                                optionLabel="nombre"
                                                optionValue="id"
                                                disabled={soloLectura}
                                              
                                            />
                                        </td>

                                        <td>
                                            {!soloLectura && (
                                                <ButtonIcon
                                                    title="Eliminar"
                                                    iconName="RiDeleteBinLine"
                                                    onClick={() => eliminar(index)}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                                        )
                            })}
                        </tbody>
                    </table>
            </div>
            <Form columns={4} values={viaje} onChange={setViaje}>
                <Field label={'Evidencia'} field={'evidencia'} render={FormClipboardImage}    required={false} cols={2}/>   
           </Form>
        </>
    );
};

export default CentroCostosPV;
